'use client'

import BusinessSolutionPage from '@/components/platform/v2/BusinessSolutionPage'
import { getSolution } from '@/data/solutions'

const B2bSolutionPageComponent = () => (
    <BusinessSolutionPage
        config={{
            meta: getSolution('b2b'),
            eyebrow: 'B2B и продажи',
            titleLines: ['B2B-продажи без потерянных договорённостей', 'и ручного контроля'],
            lead: 'Клиенты, сделки, задачи, документы, коммуникации и цифровые сервисы компании в одной системе.',
            problems: [
                { title: 'Лиды находятся в таблицах и мессенджерах' },
                { title: 'Менеджер хранит отношения с клиентом у себя' },
                { title: 'Руководитель не понимает реальный статус сделки' },
                { title: 'После продажи взаимодействие снова уходит в переписку' },
            ],
            flowTitle: 'Один процесс из любого источника',
            flow: [
                'Сайт / менеджер / мероприятие / рекомендация / офлайн',
                'Лид',
                'Компания + контакт',
                'Сделка',
                'Ответственный',
                'Задачи / коммуникации',
                'Документы / счёт',
                'Оплата',
                'Повторная продажа',
            ],
            featuresTitle: 'Что получает B2B',
            features: [
                { title: 'CRM', text: 'Контакты, компании, сделки, комментарии.' },
                { title: 'Воронки', text: 'Под разные направления бизнеса.' },
                { title: 'Задачи', text: 'Что и кому нужно сделать.' },
                { title: 'Автоматизация', text: 'Следующее действие после каждого этапа.' },
                { title: 'Документы', text: 'В одном клиентском контексте.' },
                { title: 'Клиентский кабинет / приложение', text: 'Заказы, документы, статусы, запросы, чат.' },
                { title: 'Сайт', text: 'Формы, заявки, каталог, кабинеты.' },
                { title: 'Интеграции', text: '1С, банки, CRM и другие системы.' },
            ],
            thesis: 'VCENTRE.ONE — не место, куда менеджер заносит данные. Это место, откуда компания управляет отношениями с клиентом.',
        }}
    />
)

export default B2bSolutionPageComponent
